import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-dc55f434"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sideBar"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "40",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mt-2 mx-3" }, "StreamGamesTV", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "links" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-table-columns" }),
  /*#__PURE__*/_createElementVNode("p", { class: "mx-4" }, "Dashboard")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-gear" }),
  /*#__PURE__*/_createElementVNode("p", {
    style: {"padding-left":"0.3rem"},
    class: "mx-4"
  }, "Settings")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "bottom" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }),
  /*#__PURE__*/_createElementVNode("p", {
    style: {"padding-left":"0.3rem"},
    class: "mx-4"
  }, "Logout")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<hr data-v-dc55f434><div class=\"socials\" data-v-dc55f434><a href=\"https://twitter.com/StreamGamesTV\" target=\"blank\" data-v-dc55f434><i class=\"fa-brands fa-twitter\" data-v-dc55f434></i></a><a target=\"blank\" href=\"https://www.youtube.com/channel/UC77UmGDaaE8DVgxA3EIw4cA\" data-v-dc55f434><i class=\"fa-brands fa-youtube\" data-v-dc55f434></i></a><a href=\"https://discord.com/invite/6Mmfpvf\" target=\"blank\" data-v-dc55f434><i class=\"fa-brands fa-discord\" data-v-dc55f434></i></a><a href=\"https://www.instagram.com/streamgamestv/\" target=\"blank\" data-v-dc55f434><i class=\"fa-brands fa-instagram\" data-v-dc55f434></i></a></div>", 2)

import { useRoute } from "vue-router";
import { useAuth0 } from "@auth0/auth0-vue";
import { onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

const hideNav = ref(false);

onMounted(() => {
  const route = useRoute();
  if (route.path.includes("browsersource")) {
    hideNav.value = true;
  }

  let darkmode = localStorage.getItem("darkmode");
  if (darkmode == "false" || darkmode == "true") {
    //TODO: fix darkmode
    //toggleDarkmode(darkmode);
  }
});

const isDarkmode = ref(false);

function isActive(routePath: string) {
  const route = useRoute();

  if (routePath == "/" && route.path == routePath) {
    return "active";
  } else if (routePath != "/" && route.path.includes(routePath)) {
    return "active";
  }
  return "";
}
function openBrowsersource() {
  //@ts-ignore
  window.open("/browsersource/" + authStore.userId, "_blank").focus();
}

function toDoubleNumber(number: number) {
  return number < 10 ? "0" + number : number;
}
function toggleDarkmode(darkmodeLocale?: string) {
  if (darkmodeLocale == "true") {
    isDarkmode.value = true;
  } else if (darkmodeLocale == "false") {
    isDarkmode.value = false;
  } else {
    isDarkmode.value = !isDarkmode.value;
  }

  localStorage.setItem("darkmode", "" + isDarkmode.value);

  const textElements = document.querySelectorAll(
    "p, h1, h2, h3, h4, h5, h6, div:not(:empty)"
  );

  if (isDarkmode.value) {
    document.body.style.backgroundColor = "#202124";
    textElements.forEach((paragraph) => {
      //@ts-ignore
      paragraph.style.color = "white";
    });
  } else {
    document.body.style.backgroundColor = "#fff";
    textElements.forEach((paragraph) => {
      //@ts-ignore
      paragraph.style.color = "black";
    });
  }
}

function openFeedback() {
  //@ts-ignore
  window.open("https://streamgames.tv/feedback", "_blank").focus();
}

function goToCustomerPortal() {
  //@ts-ignore
  window.open("https://customer.streamgames.tv/", "_blank").focus();
}

const auth0 = useAuth0();

function logout() {
  auth0.logout({ logoutParams: { returnTo: "https://streamgamestv.com/" } });
}


return (_ctx: any,_cache: any) => {
  return (!hideNav.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "content" }, [
          _createElementVNode("div", {
            onClick: goToCustomerPortal,
            class: "d-flex clickable"
          }, _hoisted_4)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/'))),
            class: _normalizeClass(["link", isActive('/')])
          }, _hoisted_8, 2),
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/settings'))),
            class: _normalizeClass(["link mt-2", isActive('/settings')])
          }, _hoisted_10, 2)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (logout())),
            class: "link mt-2"
          }, _hoisted_13),
          _hoisted_14
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})